import SidebarUnitDesktop from "../../components/SidebarUnitDesktop";
import {Lightning} from "../../../../assets/icons";

const QualificationDL = () => {
    return (
        <SidebarUnitDesktop 
            routeName={"Qualification"} 
            routeSidebar={"/qualification"}
            icon={Lightning}
            text="Qualification"
        />
    )
}

export default QualificationDL;